export default __webpack_public_path__ + "static/media/authyIcon.0cbd053d.png";